import { render } from "./Recipe.vue?vue&type=template&id=22b2ea5b&scoped=true"
import script from "./Recipe.vue?vue&type=script&lang=js"
export * from "./Recipe.vue?vue&type=script&lang=js"

import "./Recipe.vue?vue&type=style&index=0&id=22b2ea5b&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b2ea5b"]])

export default __exports__